import React from "react";
import { Item } from "../Item";
import { Col, Row } from "react-bootstrap";

const Company = (props) => {
  const { company, position, startDate, endDate, summary } = props;
  return (
    <>
      <Row>
        <Col>
          <Item
            col1={`${startDate} - ${endDate}`}
            col2={company}
            col3={position}
            summary={summary}
          />
        </Col>
      </Row>
    </>
  );
};

export default Company;
